export const apiActionsDP = {
    GET: "FETCH_ONE_DP",
    GET_ALL_ORGANIZATIONS: "FETCH_DPS_FOR_LIST_PAGE",
    POST: "ADD_NEW_DATA_PROVIDER",
    PUT: "UPDATE_CURRENT_DATA_PROVIDER",
    DELETE_CURRENT_DATA_PROVIDER: "DELETE_CURRENT_DATA_PROVIDER",
}

export const apiActionsDPService = {
    GET: "FETCH_ONE_DP_SERVICE",
    GET_ONE_KYB: "FETCH_ONE_KYB_SERVICE",
    GET_ALL: "FETCH_ALL_DP_SERVICES",
    GET_ALL_KYB: "FETCH_ALL_KYB_SERVICES",
    GET_ALL_KYC: "FETCH_ALL_KYC_SERVICES",
    POST: "ADD_NEW_DP_SERVICE",
    POST_KYB: "ADD_NEW_KYB_SERVICE",
    PUT: "UPDATE_CURRENT_DP_SERVICE",
    PUT_KYB: "UPDATE_KYB_SERVICE",
    DELETE_KYC_SERVICE: "DELETE_KYC_SERVICE",
    DELETE_KYB_SERVICE: "DELETE_KYB_SERVICE",
    CREATE_SERVICE_CONFIG_NAME: "CREATE_SERVICE_CONFIG_NAME",
    COPY_SERVICE: "COPY_SERVICE_CONFIG_NAME",
}

export const apiActionsDPSource = {
    GET: "FETCH_KYC_SOURCE",
    GET_KYB: "FETCH_KYB_SOURCE",
    GET_ALL: "FETCH_ALL_DP_SOURCES",
    POST: "ADD_KYC_SOURCE",
    POST_KYB: "ADD_KYB_SOURCE",
    PUT: "UPDATE_KYC_SOURCE",
    PUT_KYB: "UPDATE_KYB_SOURCE",
    DELETE_KYC_SOURCE: "DELETE_KYC_SOURCE",
    DELETE_KYB_SOURCE: "DELETE_KYB_SOURCE",
}

export const apiActionsCountries = {
    GET_ALL_COUNTRIES: "GET_ALL_COUNTRIES",
    GET: "GET_ONE_COUNTRY",
    DELETE: "DELETE_ONE_COUNTRY",
    POST: "ADD_ONE_COUNTRY",
    PUT: "UPDATE_ONE_COUNTRY"
}

export const apiActionsBillingGroups = {
    GET_ALL_BILLING_GROUPS: "FETCH_ALL_BILLING_GROUPS",
    GET: "FETCH_ONE_BILLING_GROUP",
    POST: "POST_NEW_BILLING_GROUP",
    PUT: "UPDATE_CURRENT_BILLING_GROUP",
    DELETE: "DELETE_CURRENT_BILLING_GROUP",
}

export const apiActionsBillingGroupPricing = {
    GET: "FETCH_ONE_BG_PRICING_TABLE",
    POST: "POST_NEW_BG_COUNTRY_PRICING",
    PUT: "UPDATE_CURRENT_BG_COUNTRY_PRICING",
    DELETE: "DELETE_CURRENT_BG_COUNTRY_PRICING",
}
